/* lua.js generated code 0.3.0 */

var Event = require("cocos/framework/components/event")
var MarkPriseWxChestButton = xClass("MarkPriseWxChestButton", Event, function () {
    // WARN: maybe multi result
    return cc.CSLoader.createNode("cocos/homeScene_mark_prise.csb")
})
var MarkPriseWxChestButtonEvent = table([1, "TimeUp", "MARKPRISEWXCHESTBUTTONEVENT.TIMEUP"])
MarkPriseWxChestButton.prototype.ctor = function (endTime, clicked) {
    var self = this
    self.endTime = endTime
    self.nodeExist = true
    self.visible = true
    self.clicked = clicked
    self.hided = false
    self.bind(self)
    self.btn = null
    self.init()
}
MarkPriseWxChestButton.prototype.init = function () {
    var self = this
    var btn = UIButton.create(self.getChildByName("icon"), true)
    self.btn = btn
    var clickLayer = cc.Layer.create()
    clickLayer.setContentSize(140, 120)
    clickLayer.setAnchorPoint(0.5, 0.5)
    clickLayer.setPositionX(self.getChildByName("time").getPositionX() - 40)
    clickLayer.setPositionY(self.getChildByName("time").getPositionY() - 40)
    clickLayer.setCascadeOpacityEnabled(true)

    
    let oldTime = self.getChildByName("time")
    oldTime.removeFromParent(true)
    
    self.addChild(clickLayer)
    var getRewardBTN = UIButton.create(clickLayer)
    getRewardBTN.setCascadeOpacityEnabled(true)
    getRewardBTN.on(UIButtonEvent.Click, handler(self, self.onClick))

    function refresh() {
        var time = self.getChildByName("time")
        if (!time) {
            return 
        }
        time.setString(UIUtils.formatTime(Math.max(self.endTime - Localhost.time(), 0)))
        var size = time.getContentSize()
        size.width = 100
        size.height = 50
        time.setPositionX(-size.width * time.getScaleX() / 2 - 4.5)
        if (self.endTime - Localhost.time() < 0) {
            self.dispatchEvent(table([1, "name", MarkPriseWxChestButtonEvent.TimeUp]))
        }
    }

    if (!self.clicked) {
        let time = cc.LabelTTF.create(self.text, FONT_DEF.microsoftYahei_24_blueStroke)
        time.setPosition(oldTime.getPosition())
        time.setScale(0.9)
        time.setAnchorPoint(oldTime.getAnchorPoint())
        time.setName("time")
        time.y = -22
        self.addChild(time)
        time.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.CallFunc.create(refresh), cc.DelayTime.create(1))))
        time.setVisible(!self.clicked)
    }

    self.rewardText = cc.Sprite.createWithSpriteFrameName("homeScene/rewardtxt1.png")
    self.rewardText.y = -50
    self.addChild(self.rewardText, 0, "reward")
    self.rewardText.setVisible(self.clicked)
}
MarkPriseWxChestButton.prototype.setClicked = function (clicked) {
    var self = this
    self.clicked = clicked
    var time = self.getChildByName("time")
    if (time && clicked) {
        time.removeFromParent(true)
    } 
    time && time.setVisible(!self.clicked && self.visible && !self.hided)
    self.rewardText.setVisible(self.clicked && self.visible && !self.hided)
}
MarkPriseWxChestButton.prototype.getClicked = function () {
    var self = this
    return self.clicked
}
MarkPriseWxChestButton.prototype.setEndTime = function (endTime) {
    var self = this
    self.endTime = endTime
}
MarkPriseWxChestButton.prototype.getEndTime = function () {
    var self = this
    return self.endTime
}
MarkPriseWxChestButton.prototype.setVisible = function (visible) {
    var self = this
    self.visible = visible
    self.btn.setVisible(self.visible && !self.hided)
    var time = self.getChildByName("time")
    if (time && self.clicked) {
        time.removeFromParent(true)
    } 
    time && time.setVisible(!self.clicked && self.visible && !self.hided)
    self.rewardText.setVisible(self.clicked && self.visible && !self.hided)
}
MarkPriseWxChestButton.prototype.setHided = function (hided) {
    var self = this
    self.hided = hided
    self.btn.setVisible(self.visible && !self.hided)
    var time = self.getChildByName("time")
    if (time && self.clicked) {
        time.removeFromParent(true)
    } 
    time && time.setVisible(!self.clicked && self.visible && !self.hided)
    self.rewardText.setVisible(self.clicked && self.visible && !self.hided)
}
MarkPriseWxChestButton.prototype.onClick = function () {
    var self = this
    var [v00, v11] = self.getAnglePosition()
    var MarkPriseWxChestLogic = require("clover/panelBusLogic/MarkPriseWxChestLogic")
    MarkPriseWxChestLogic.create().start(null, table([1, "p00", v00], [1, "p11", v11]), table([1, "p00", v00], [1, "p11", v11]))
    DCAssist.dc4OpenModule(ModuleName.MARK_LIMIT_GIFT)
}
MarkPriseWxChestButton.prototype.shakeBox = function (clicked) {
    var self = this
    if (self.endTime - Localhost.time() < 0) {
        self.dispatchEvent(table([1, "name", MarkPriseWxChestButtonEvent.TimeUp]))
    }
    if (!self.visible || self.hided) {
        return 
    }
    self.clicked = clicked
    var time = self.getChildByName("time")
    if (time && self.clicked) {
        time.removeFromParent(true)
    } 
    time && time.setVisible(!clicked && self.visible && !self.hided)
    self.rewardText.setVisible(self.clicked && self.visible && !self.hided)
    self.btn.runAction(cc.Sequence.create(cc.Repeat.create(cc.Sequence.create(cc.RotateTo.create(0.1, -15), cc.RotateTo.create(0.1, 15)), 2), cc.RotateTo.create(0.1, 0)))
    
}
MarkPriseWxChestButton.prototype.getAnglePosition = function () {
    var self = this
    var icon = self.getChildByName("icon")
    var size = icon.getContentSize()
    var pos = cc.p(icon.getPosition())
    var v00 = self.convertToWorldSpace(cc.p(pos.x - size.width * icon.getScaleX() / 2, pos.y - size.height * icon.getScaleY() / 2))
    var v11 = self.convertToWorldSpace(cc.p(pos.x + size.width * icon.getScaleX() / 2, pos.y + size.height * icon.getScaleY() / 2))
    return [v00, v11]
}
module.exports = table([0, MarkPriseWxChestButton], [0, MarkPriseWxChestButtonEvent])
